module.exports = __webpack_public_path__ + "img/Time.e93ce2cd.svg";